/* eslint-disable max-classes-per-file */
import { Crop } from '@next/arable-lib/crop';
import { Action } from '@ngrx/store';
import { Feature } from 'src/app/geo/models';
import {
  CropField,
  EditCropFieldsOptions,
  CreateCropFieldsOptions,
  AgroConnectCustomer,
  AgroConnectExternalParty,
  AgroConnectCropField,
  ChangedCropFields,
  CropFieldType,
  CropFieldSyncDto,
  ExternalCropFieldSources,
} from 'src/app/shared/models';

export enum CropFieldActionTypes {
  LoadCropFieldsRequestInitial = '[CropField] Load CropFields request initial',
  LoadCropFieldsRequest = '[CropField] Load CropFields request',
  LoadCropFieldsSuccess = '[CropField] Load CropFields success',
  LoadCropFieldsFailed = '[CropField] Load CropFields failed',
  UpsertCropFieldRequest = '[CropField] Upsert CropField request',
  UpsertCropFieldSuccess = '[CropField] Upsert CropField success',
  UpsertCropFieldFailed = '[CropField] Upsert CropField failed',
  DeleteCropFields = '[CropField] Delete CropFields',
  DeleteCropFieldRequest = '[CropField] Delete CropField request',
  DeleteCropFieldSuccess = '[CropField] Delete CropField success',
  DeleteCropFieldFailed = '[CropField] Delete CropField failed',
  SelectCropField = '[CropField] Select CropField',
  DeselectCropField = '[CropField] Deselect CropField',
  LoadLastYearsCropFieldsRequest = '[CropField] Load last years CropFields request',
  LoadLastYearsCropFieldsSuccess = '[CropField] Load last years CropFields success',
  InteractionCropFieldSelected = '[CropField] Interaction CropField selected',
  InteractionCropFieldDeselected = '[CropField] Interaction CropField deselected',
  AddOrEditCropField = '[CropField] Add or edit CropField',
  CloneSelectedCropField = '[CropField] Clone selected CropField',
  CloneSelectedRvoField = '[CropField] Clone selected Rvo Field',
  AddCropField = '[CropField] Add CropField with feature',
  EditCropFields = '[CropField] Edit CropFields',
  EditSelectedCropFields = '[CropField] Edit selected CropFields',
  SendSelectedCropFields = '[CropField] Send selected CropFields',
  PrefillCropField = '[CropField] Set prefill CropField',
  SetFilteredCropFieldIds = '[CropField] Set filtered CropField ids',
  CreateSubsequentCultivation = '[CropField] Create a subsequent cultivation',
  DivideField = '[CropField] Divide field',
  CombineFields = '[CropField] Combine fields',
  DrawFieldOverlap = '[CropField] Draw field overlap',
  DeleteOriginalFields = '[CropField] Delete original fields',
  OpenSoilAnalysesReportForSelectedCropFields = '[CropField] Open soil analyses report for selected CropFields',
  EditMachiningDepth = '[CropField] Edit machining Depth',
  SaveMachiningDepth = '[CropField] Save machining Depth',
  UpdateMachiningDepthSuccess = '[CropField] Update machining depth success',
  QuickEditCropFields = '[CropField] Quick edit',
  CopyCropFieldsToManureSpace = '[CropField] Copy cropfields from advice to manure space',
  LoadMostUsedCropsRequest = '[CropField] Load most used crops request',
  LoadMostUsedCropsSuccess = '[CropField] Load most used crops success',
  LoadMostUsedCropsFailed = '[CropField] Load most used crops failed',
  LoadAgroConnectCustomersRequest = '[CropField] Load agroconnect customers request',
  LoadAgroConnectCustomersSuccess = '[CropField] Load agroconnect customers success',
  AskSynchronizeCropFields = '[CropField] Ask synchronize crop fields',
  AskSynchronizeCropFieldsWithRvO = '[CropField] Ask synchronize crop fields for RvO',
  AskImportRegulatoryManureFields = '[CropField] Ask import regulatory manure fields',
  AskImportCropFields = '[CropField] Ask import crop fields',
  AskImportCropFieldsFromSync = '[CropField] Ask import crop fields from sync',
  LoadRvOCropFieldsRequest = '[CropField] Load RvO crop fields request',
  LoadRvOCropFieldsSuccess = '[CropField] Load RvO crop fields success',
  AskImportCropFieldsForRvO = '[CropField] Ask import crop fields for RvO',
  UpsertImportedCropFieldsRequest = '[CropField] upsert imported crop fields request',
  UpsertImportedCropFieldsSuccess = '[CropField] upsert imported crop fields success',
  SelectCustomerForImport = '[CropField] Select customer for import',
  SelectCropYearForImportFromCustomer = '[CropField] Select cropyear for import from customer',
  RetrieveCropFieldsFromCustomerForImport = '[CropField] Retrieve cropfields fromc ustomer for import',
  LoadCropFieldsFromCustomerSuccess = '[CropField] Load cropfields from customer success',
  SelectCropFieldsForImportFromCustomer = '[CropField] Select cropfields for import from customer',
  LoadCropFieldsForRvOSuccess = '[CropField] Load cropfields from customer success',

  // V2 Sync Actions
  TriggerSyncCropFieldsV2Request = '[CropField] Trigger sync crop fields V2 request',
  TriggerSyncCropFieldsV2Failed = '[CropField] Trigger sync crop fields V2 failed',
  SyncCropFieldsReadySubmitted = '[CropField] Sync crop fields ready submitted',
  SyncCropFieldsReadyReceived = '[CropField] Sync crop fields ready received',
  LoadCropFieldsSyncPreviewV2Success = '[CropField] Load crop fields sync preview V2 success',
  CompleteSyncCropFieldsV2Request = '[CropField] Complete sync crop fields V2 request',
  IsAwaitingCropFieldsSync = '[CropField] Set sync crop fields triggered',
  SetCropFieldsSyncId = '[CropField] Set sync crop fields Id',
}

export class LoadCropFieldsRequest implements Action {
  readonly type = CropFieldActionTypes.LoadCropFieldsRequest;
  constructor(public readonly centerMap = false) {}
}

export class LoadCropFieldsSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadCropFieldsSuccess;

  constructor(public readonly cropFields: CropField[]) {}
}

export class LoadCropFieldsFailed implements Action {
  readonly type = CropFieldActionTypes.LoadCropFieldsFailed;

  constructor(public readonly message: string) {}
}

export class UpsertCropFieldRequest implements Action {
  readonly type = CropFieldActionTypes.UpsertCropFieldRequest;

  constructor(
    public readonly cropField: CropField,
    public readonly createOptions?: CreateCropFieldsOptions,
  ) {}
}

export class UpsertCropFieldSuccess implements Action {
  readonly type = CropFieldActionTypes.UpsertCropFieldSuccess;

  constructor(
    public readonly cropField: CropField,
    public readonly created: boolean,
  ) {}
}

export class UpsertCropFieldFailed implements Action {
  readonly type = CropFieldActionTypes.UpsertCropFieldFailed;

  constructor(public readonly message: string) {}
}
export class DeleteCropFields implements Action {
  readonly type = CropFieldActionTypes.DeleteCropFields;

  constructor() {}
}

export class DeleteCropFieldRequest implements Action {
  readonly type = CropFieldActionTypes.DeleteCropFieldRequest;

  constructor(public readonly id: number) {}
}

export class DeleteCropFieldSuccess implements Action {
  readonly type = CropFieldActionTypes.DeleteCropFieldSuccess;

  constructor(public readonly id: number) {}
}

export class DeleteCropFieldFailed implements Action {
  readonly type = CropFieldActionTypes.DeleteCropFieldFailed;

  constructor(public readonly message: string) {}
}

export class AddOrEditCropField implements Action {
  readonly type = CropFieldActionTypes.AddOrEditCropField;
  constructor() {}
}

export class CloneSelectedCropField implements Action {
  readonly type = CropFieldActionTypes.CloneSelectedCropField;
  constructor() {}
}

export class CloneSelectedRvoField implements Action {
  readonly type = CropFieldActionTypes.CloneSelectedRvoField;
  constructor() {}
}

export class AddCropField implements Action {
  readonly type = CropFieldActionTypes.AddCropField;
  constructor(
    public readonly feature: Feature,
    public readonly createOptions?: CreateCropFieldsOptions,
  ) {}
}

export class EditCropFields implements Action {
  readonly type = CropFieldActionTypes.EditCropFields;
  constructor(
    public readonly cropFields: CropField[],
    public readonly editOptions?: EditCropFieldsOptions,
    public readonly createOptions?: CreateCropFieldsOptions,
  ) {}
}

export class EditSelectedCropFields implements Action {
  readonly type = CropFieldActionTypes.EditSelectedCropFields;
  constructor() {}
}

export class SendSelectedCropFields implements Action {
  readonly type = CropFieldActionTypes.SendSelectedCropFields;
  constructor() {}
}

export class PrefillCropField implements Action {
  readonly type = CropFieldActionTypes.PrefillCropField;
  constructor(public readonly isPrefilling: boolean) {}
}

export class LoadLastYearsCropFieldsRequest implements Action {
  readonly type = CropFieldActionTypes.LoadLastYearsCropFieldsRequest;
  constructor(public readonly centerMap = false) {}
}

export class LoadLastYearsCropFieldsSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadLastYearsCropFieldsSuccess;

  constructor(public readonly cropFields: CropField[]) {}
}

export class SetFilteredCropFieldIds implements Action {
  readonly type = CropFieldActionTypes.SetFilteredCropFieldIds;
  constructor(public readonly filteredIds: number[]) {}
}

export class CreateSubsequentCultivation implements Action {
  readonly type = CropFieldActionTypes.CreateSubsequentCultivation;
  constructor() {}
}

export class DivideField implements Action {
  readonly type = CropFieldActionTypes.DivideField;
  constructor() {}
}

export class CombineFields implements Action {
  readonly type = CropFieldActionTypes.CombineFields;
  constructor() {}
}

export class DrawFieldOverlap implements Action {
  readonly type = CropFieldActionTypes.DrawFieldOverlap;
  constructor() {}
}

export class DeleteOriginalFields implements Action {
  readonly type = CropFieldActionTypes.DeleteOriginalFields;
  constructor(public readonly cropFields: CropField[]) {}
}

export class OpenSoilAnalysesReportForSelectedCropFields implements Action {
  readonly type = CropFieldActionTypes.OpenSoilAnalysesReportForSelectedCropFields;
  constructor() {}
}

export class EditMachiningDepth implements Action {
  readonly type = CropFieldActionTypes.EditMachiningDepth;
  constructor() {}
}

export class SaveMachiningDepth implements Action {
  readonly type = CropFieldActionTypes.SaveMachiningDepth;
  constructor(
    public readonly id: number,
    public readonly machiningDepthInCentimeters: number,
  ) {}
}

export class UpdateMachiningDepthSuccess implements Action {
  readonly type = CropFieldActionTypes.UpdateMachiningDepthSuccess;
  constructor(
    public readonly id: number,
    public readonly machiningDepthInCentimeters: number,
  ) {}
}

export class QuickEditCropFields implements Action {
  readonly type = CropFieldActionTypes.QuickEditCropFields;
  constructor() {}
}

export class CopyFieldsToManureSpace implements Action {
  readonly type = CropFieldActionTypes.CopyCropFieldsToManureSpace;
  constructor() {}
}
export class LoadMostUsedCropsRequest implements Action {
  readonly type = CropFieldActionTypes.LoadMostUsedCropsRequest;
}

export class LoadMostUsedCropsSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadMostUsedCropsSuccess;

  constructor(public readonly crops: Crop[]) {}
}

export class LoadMostUsedCropsFailed implements Action {
  readonly type = CropFieldActionTypes.LoadMostUsedCropsFailed;

  constructor(public readonly message: string) {}
}

export class LoadAgroConnectCustomersRequest implements Action {
  readonly type = CropFieldActionTypes.LoadAgroConnectCustomersRequest;
  constructor(
    public readonly provider: AgroConnectExternalParty,
    public readonly year: number,
  ) {}
}

export class LoadAgroConnectCustomersSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadAgroConnectCustomersSuccess;
  constructor(public readonly agroConnectCustomers: AgroConnectCustomer[]) {}
}

export class AskSynchronizeCropFields implements Action {
  readonly type = CropFieldActionTypes.AskSynchronizeCropFields;
}

export class AskSynchronizeCropFieldsRvO implements Action {
  readonly type = CropFieldActionTypes.AskSynchronizeCropFieldsWithRvO;
}

export class AskImportRegulatoryManureFields implements Action {
  readonly type = CropFieldActionTypes.AskImportRegulatoryManureFields;
}

export class AskImportCropFields implements Action {
  readonly type = CropFieldActionTypes.AskImportCropFields;
  constructor(public readonly cropFields: CropField[]) {}
}

export class AskImportCropFieldsFromSync implements Action {
  readonly type = CropFieldActionTypes.AskImportCropFieldsFromSync;
  constructor(
    public readonly newCropFields: CropField[],
    public readonly deletedCropFields: AgroConnectCropField[],
    public readonly changedCropFields: ChangedCropFields,
    public readonly provider: string,
  ) {}
}

export class LoadRvOCropFieldsRequest implements Action {
  readonly type = CropFieldActionTypes.LoadRvOCropFieldsRequest;
  constructor(
    public readonly kvkNumber: string,
    public readonly year: number,
  ) {}
}

export class LoadRvOCropFieldsSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadRvOCropFieldsSuccess;
  constructor(public readonly rvoCropFields: AgroConnectCropField[]) {}
}

export class AskImportCropFieldsForRvO implements Action {
  readonly type = CropFieldActionTypes.AskImportCropFieldsForRvO;
  constructor(public readonly cropFields: CropField[]) {}
}

export class UpsertImportedCropFieldsRequest implements Action {
  readonly type = CropFieldActionTypes.UpsertImportedCropFieldsRequest;
  constructor(
    public readonly cropFields: CropField[],
    public readonly year: number,
    public readonly useLayerData = true,
    public readonly externalSource?: string,
  ) {}
}

export class UpsertImportedCropFieldsSuccess implements Action {
  readonly type = CropFieldActionTypes.UpsertImportedCropFieldsSuccess;
}

export class SelectCustomerForImport implements Action {
  readonly type = CropFieldActionTypes.SelectCustomerForImport;
}

export class SelectCropYearForImportFromCustomer implements Action {
  readonly type = CropFieldActionTypes.SelectCropYearForImportFromCustomer;
  constructor(public readonly customerId: number) {}
}

export class RetrieveCropFieldsFromCustomerForImport implements Action {
  readonly type = CropFieldActionTypes.RetrieveCropFieldsFromCustomerForImport;
  constructor(
    public readonly customerId: number,
    public readonly cropYear: number,
  ) {}
}

export class LoadCropFieldsFromCustomerSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadCropFieldsFromCustomerSuccess;
  constructor(
    public readonly cropFields: CropField[],
    public readonly year: number,
  ) {}
}

export class SelectCropFieldsForImportFromCustomer implements Action {
  readonly type = CropFieldActionTypes.SelectCropFieldsForImportFromCustomer;
  constructor(
    public readonly cropFields: CropField[],
    public readonly year: number,
  ) {}
}

export class LoadCropFieldsForRvOSuccess implements Action {
  readonly type = CropFieldActionTypes.LoadCropFieldsForRvOSuccess;
  constructor(
    public readonly cropFields: CropField[],
    public readonly year: number,
  ) {}
}

// V2 Sync Action Classes

export class TriggerSyncCropFieldsV2Request implements Action {
  readonly type = CropFieldActionTypes.TriggerSyncCropFieldsV2Request;
  constructor(
    public readonly searchYear: number,
    public readonly cropFieldType: CropFieldType,
    public readonly externalCropFieldSource: string,
    public readonly externalId: string,
  ) {}
}

export class SyncCropFieldsReadySubmitted implements Action {
  readonly type = CropFieldActionTypes.SyncCropFieldsReadySubmitted;
  constructor(
    public readonly searchYear: number,
    public readonly externalId: string,
    public readonly externalCropFieldSource: ExternalCropFieldSources,
    public readonly succeeded: boolean,
    public readonly errorCode?: string[],
  ) {}
}

export class TriggerSyncCropFieldsV2Failed implements Action {
  readonly type = CropFieldActionTypes.TriggerSyncCropFieldsV2Failed;
  constructor(public readonly error: string) {}
}

export class SyncCropFieldsReadyReceived implements Action {
  readonly type = CropFieldActionTypes.SyncCropFieldsReadyReceived;
  constructor(
    public readonly searchYear: number,
    public readonly externalId: string,
    public readonly externalCropFieldSource: ExternalCropFieldSources,
    public readonly succeeded: boolean,
    public readonly errorCode?: string[],
    public readonly syncId?: Date,
  ) {}
}

export class LoadCropFieldsSyncPreviewV2Success implements Action {
  readonly type = CropFieldActionTypes.LoadCropFieldsSyncPreviewV2Success;
  constructor(
    public readonly syncData: CropFieldSyncDto,
    public readonly externalCropFieldSource: ExternalCropFieldSources,
    public readonly externalId: string,
  ) {}
}

export class CompleteSyncCropFieldsV2Request implements Action {
  readonly type = CropFieldActionTypes.CompleteSyncCropFieldsV2Request;
  constructor(
    public readonly cropYear: number,
    public readonly externalCropFieldSource: ExternalCropFieldSources,
    public readonly externalId: string,
    public readonly selectedNewExternalIds: string[],
    public readonly selectedChangedExternalIds: string[],
  ) {}
}

export class IsAwaitingCropFieldsSync implements Action {
  readonly type = CropFieldActionTypes.IsAwaitingCropFieldsSync;
  constructor(public readonly isAwaiting: boolean) {}
}

export class SetCropFieldsSyncId implements Action {
  readonly type = CropFieldActionTypes.SetCropFieldsSyncId;
  constructor(public readonly syncId: Date) {}
}

export type CropFieldActions =
  | LoadCropFieldsRequest
  | LoadCropFieldsSuccess
  | LoadCropFieldsFailed
  | UpsertCropFieldRequest
  | UpsertCropFieldSuccess
  | UpsertCropFieldFailed
  | DeleteCropFields
  | DeleteCropFieldRequest
  | DeleteCropFieldSuccess
  | DeleteCropFieldFailed
  | LoadLastYearsCropFieldsRequest
  | LoadLastYearsCropFieldsSuccess
  | CloneSelectedCropField
  | CloneSelectedRvoField
  | AddCropField
  | EditCropFields
  | EditSelectedCropFields
  | SendSelectedCropFields
  | PrefillCropField
  | SetFilteredCropFieldIds
  | CreateSubsequentCultivation
  | DivideField
  | CombineFields
  | DrawFieldOverlap
  | DeleteOriginalFields
  | OpenSoilAnalysesReportForSelectedCropFields
  | EditMachiningDepth
  | SaveMachiningDepth
  | UpdateMachiningDepthSuccess
  | QuickEditCropFields
  | CopyFieldsToManureSpace
  | LoadMostUsedCropsRequest
  | LoadMostUsedCropsSuccess
  | LoadMostUsedCropsFailed
  | LoadAgroConnectCustomersRequest
  | LoadAgroConnectCustomersSuccess
  | AskImportCropFields
  | LoadRvOCropFieldsRequest
  | LoadRvOCropFieldsSuccess
  | AskImportCropFieldsForRvO
  | UpsertImportedCropFieldsRequest
  | UpsertImportedCropFieldsSuccess
  | SelectCustomerForImport
  | SelectCropYearForImportFromCustomer
  | RetrieveCropFieldsFromCustomerForImport
  | LoadCropFieldsFromCustomerSuccess
  | SelectCropFieldsForImportFromCustomer
  | LoadCropFieldsForRvOSuccess
  | AskSynchronizeCropFields
  | AskSynchronizeCropFieldsRvO
  | TriggerSyncCropFieldsV2Request
  | TriggerSyncCropFieldsV2Failed
  | SyncCropFieldsReadyReceived
  | LoadCropFieldsSyncPreviewV2Success
  | IsAwaitingCropFieldsSync
  | SetCropFieldsSyncId
  | CompleteSyncCropFieldsV2Request;
